import { createReducer, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';
import {
  newMessageTask,
  newMessageFlow,
  clearTaskLog,
  getTaskChat,
} from './actions';

/**
   
task: [{
  id: xxx,
  log: {}
}]
  
 */

const initialState = {
  flow: {
    log: [],
    status: 'idle',
  },
  task: [],
};

export const fetchFlowChat = createAsyncThunk(
  'activedFlows/chat/flow',
  async ({ refId }, { rejectWithValue }) => {
    try {
      const response = await api.get('/activedflows/chat/flow/' + refId);

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

const reducers = {
  [newMessageTask]: (state, action) => {
    const chatMessage = action.payload.chatMessage;
    const id = chatMessage.refId;

    const alreadyExists = state.task.find((item) => item.id === id);

    if (alreadyExists) {
      state.task = state.task.map((item) =>
        item.id === id
          ? (item = { ...item, log: [chatMessage, ...item.log] })
          : item
      );
    } else {
      state.task.push({ log: [...chatMessage], id });
    }

    // state.task.log = [chatMessage, ...state.task.log];
  },

  [newMessageFlow]: (state, action) => {
    const chatMessage = action.payload.chatMessage;

    state.flow.log = [chatMessage, ...state.flow.log];
  },

  [fetchFlowChat.pending]: (state, action) => {
    state.flow.status = 'loading';
  },

  [getTaskChat]: (state, action) => {
    const log = action.payload.data.chatLog;
    const id = action.payload.refId;

    const alreadyExists = state.task.find((item) => item.id === id);

    if (alreadyExists) {
      state.task = state.task.map((item) =>
        item.id === id ? (item = { ...item, log }) : item
      );
    } else {
      state.task.push({ log, id });
    }
  },

  [fetchFlowChat.fulfilled]: (state, action) => {
    state.flow.status = 'succeeded';
    state.flow.log = action.payload.chatLog;
  },

  [clearTaskLog]: (state) => {
    state.task = [];
  },
};

const chatReducer = createReducer(initialState, reducers);

export default chatReducer;
